import axios from 'axios'

const getParameters = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/system-parameter`)
  return data
}

export {
  getParameters
}
